import signedFetch from '../util/signedFetch.js';

export default orgId =>
  signedFetch('ngsGetClassesAndStudents', `${__API_BASE__}/ngs/org/${orgId}/classes-and-students`);
